import { roles } from '@shared/static/roles';

const balanceItem = {
  text: 'Balance',
  icon: 'balance',
  path: '/balances',
  disabled: ['onboarding', 'frozen'],
};

const supportItem = {
  text: 'Support',
  icon: 'support',
  path: '/support',
  disabled: ['frozen'],
};

const referralsItem = {
  text: 'Referrals',
  icon: 'referrals',
  path: '/referrals',
  disabled: ['onboarding', 'frozen'],
  exclude: [roles.TEAM_MEMBER, roles.TEAM_LEAD],
};

export const userTopMenu = [
  { text: 'Dashboard', icon: 'dashboard', path: '/', disabled: [] },
  {
    text: 'Cards',
    icon: 'cards',
    path: '/cards',
    disabled: ['onboarding', 'frozen'],
  },
  balanceItem,
  {
    text: 'Transactions',
    icon: 'transactions',
    path: '/transactions',
    disabled: ['onboarding', 'frozen'],
  },
  {
    text: 'Teams',
    icon: 'teams',
    path: '/teams',
    exclude: [roles.TEAM_MEMBER],
    disabled: ['onboarding', 'frozen'],
  },
];

export const userBottomMenu = [
  supportItem,
  referralsItem,
  { text: '', icon: '', path: '/profile', disabled: ['frozen'] },
];

export const moreMenu = [
  balanceItem,
  { text: 'Profile', icon: 'profile', path: '/profile', disabled: ['frozen'] },
  supportItem,
  referralsItem,
];

export const userMenu = [...userTopMenu, ...userBottomMenu, ...moreMenu];

export const isMenuItemDisabled = (item, isUnverified, isFrozen) =>
  Boolean(
    (item.disabled?.includes('onboarding') && isUnverified) ||
    (item.disabled?.includes('frozen') && isFrozen),
  );
